import React, { useState } from "react";
import "./index.scss";
import Button from "../Button";
import RightArrow from "../../assets/Icons/go.svg";
import RightArrowWhite from "../../assets/Icons/accordian_white.svg";
import DownloadRed from "../../assets/Icons/download1.svg";

import { Tooltip } from "@material-ui/core";
import { Link } from "gatsby";

function FeatureCard({ megaviewData, isShowTitle = true }) {
  const [isHover, setIsHover] = useState(false);

  return (
    <>
      {megaviewData?.map((item, index) => (
        <div className="feature-card" key={index}>
          {isShowTitle && (
            <div className="feature-card-title">
              <h4>{item?.type}</h4>
            </div>
          )}
          <div className="feature-card-body">
            <div className="feature-card-body-left">
              <div className="feature-card-body-img">
                <img
                  // className="item-one"
                  src={item?.mega_view_image}
                  alt={item?.imageAltTxt}
                />
              </div>
              <div className="feature-card-body-icon">
                {item.download !== undefined
                  ? item.download
                  : "" === "no"
                  ? ""
                  : item.slug_type !== "article" &&
                    item.type !== "Client Brief" && (
                      // props.gatedContent === 1 && }
                      <Link
                        target="_blank"
                        to={`/${item.slug_type}/${item.slug}#gated`}
                      >
                        <Tooltip title="Download" placement="bottom">
                          <div className="icon-main download-icon"></div>
                        </Tooltip>
                      </Link>
                    )}
                {/*  */}
                {item.slug_type != "Client Brief" && (
                  <Link target="_blank" to={`/${item.slug_type}/${item.slug}/`}>
                    <Tooltip title="Preview" placement="bottom">
                      <div className="icon-main preview-icon"></div>
                    </Tooltip>
                  </Link>
                )}
              </div>
            </div>
            <div className="feature-card-body-right">
              <Link
                target="_blank"
                style={{ textDecoration: "none", color: "black" }}
                to={`/${item.slug_type}/${item.slug}`}
              >
                <h4 className="article-card-title-text">{item?.title}</h4>
              </Link>
              <p className="mega-view-content">{item?.primary_description_1}</p>
              <div className="feature-card-body-btn">
                <Button
                  icon={
                    <img
                      className="effect-btn-svgicon"
                      src={!isHover ? RightArrow : RightArrowWhite}
                      style={{ color: "white" }}
                      alt="MORE ARTICLES"
                    />
                  }
                  customClassName="info-view-resize-btn feature-button-bg"
                  color="primary"
                  variant="outlined"
                  label="Find out More"
                  routepath={`/${item.slug_type}/${item.slug}/`}
                  tip="Find out More"
                  tooltip="no"
                />
                <Button
                  icon={
                    <img
                      className="effect-btn-svgicon"
                      src={DownloadRed}
                      style={{ color: "white" }}
                      alt="MORE ARTICLES"
                    />
                  }
                  customClassName="info-view-resize-btn feature-button-btn"
                  color="primary"
                  variant="outlined"
                  label="Download Now"
                  routepath={`/${item.slug_type}/${item.slug}#gated`}
                  tip="Download Now"
                  tooltip="no"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default FeatureCard;
